// reducer.js
import {
  SET_VALUE_ModelePmes,
  SET_TYPE_ModelePmes,
  SET_CURRENT_PAGE_ModelePmes,
  SET_ORDER_ModelePmes,
  SET_SORT_FIELD_ModelePmes,
  SET_ACTIF_ModelePmes,
  SET_CATEGORIE_ModelePmes,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "desc",
  sortField: "cree_le",
  categorie: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_ModelePmes:
      return {
        ...state,
        value: action.payload,
      };
    case SET_CATEGORIE_ModelePmes:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_TYPE_ModelePmes:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_ModelePmes:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_ModelePmes:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_ModelePmes:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_ModelePmes:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
